import { render, staticRenderFns } from "./intro.vue?vue&type=template&id=bae5723e&scoped=true&"
import script from "./intro.vue?vue&type=script&lang=js&"
export * from "./intro.vue?vue&type=script&lang=js&"
import style0 from "./intro.vue?vue&type=style&index=0&id=bae5723e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae5723e",
  null
  
)

/* custom blocks */
import block0 from "./intro.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports